import { render, staticRenderFns } from "./HallOfFame.vue?vue&type=template&id=dd16ff68&"
import script from "./HallOfFame.vue?vue&type=script&lang=js&"
export * from "./HallOfFame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports